import { IUserDraft } from '../model/schema';

export const createAvatarFallback = (user: IUserDraft) => {
  if (!user.user_first_name || !user.user_last_name) {
    return '';
  }

  return `${user.user_first_name[0]}${user.user_last_name[0]}`;
};

export const getFullName = (user: IUserDraft) => {
  if (!user.user_first_name || !user.user_last_name) {
    return '';
  }

  return `${user.user_first_name} ${user.user_last_name}`;
};
